import { render, staticRenderFns } from "./Func53AlterarResponsavel.vue?vue&type=template&id=43de710a&scoped=true"
import script from "./Func53AlterarResponsavel.vue?vue&type=script&lang=js"
export * from "./Func53AlterarResponsavel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43de710a",
  null
  
)

export default component.exports